/* Shared Size Chart data and presentation; gender is supplied by the owning builder. */
(function () {
  'use strict';
  if (window.ptSizeGuideBound) return;
  window.ptSizeGuideBound = true;
  var customerTypes = { WOMEN: 'WOMAN', MEN: 'MAN', GIRLS: 'GIRL', BOYS: 'BOY' };

  // One resolver for the existing guide and builder sizing.
  function resolveChart(gender) {
    var modal = document.getElementById('modal-pt-size-guide');
    if (!modal) return null;
    var customerType = customerTypes[gender];
    return Array.from(modal.querySelectorAll('template[data-pt-size-chart]')).find(function (entry) {
      return entry.dataset.ptSizeChart === customerType;
    });
  }

  // Normalize only the lookup key; never write it back to a size option/state.
  function sizeKey(size, gender) {
    var key = size.trim().toUpperCase().replace(/[–—]/g, '-').replace(/\s+/g, '');
    if (gender === 'GIRLS' || gender === 'BOYS') key = key.replace(/^(\d+-\d+)(?:Y|YR|YRS|YEARS)$/, '$1');
    return key;
  }

  function measurements(gender, size, fields) {
    if (!size || /^(custom|custom size)$/i.test(size.trim())) return '';
    var chart = resolveChart(gender);
    if (!chart) return '';
    // Rows are emitted by the guide's aligned Size/measurement-list loop.
    var row = Array.from(chart.content.querySelectorAll('[data-pt-chart-size]')).find(function (entry) {
      return sizeKey(entry.dataset.ptChartSize, gender) === sizeKey(size, gender);
    });
    if (!row) return '';
    var unit = (chart.dataset.unit || '').trim().toLowerCase();
    var suffix = /^(in|inch|inches)$/.test(unit) ? '"' : (unit ? ' ' + unit : '');
    return fields.map(function (field) {
      var cell = row.querySelector('[data-pt-measurement="' + field + '"]');
      var value = cell ? cell.textContent.trim() : '';
      if (!value || /^[—–-]$/.test(value)) return '';
      return field.charAt(0).toUpperCase() + field.slice(1) + ' ' + value + suffix;
    }).filter(Boolean).join(' · ');
  }

  window.PTSizeGuide = {
    standardSizes: function (gender) {
      var chart = resolveChart(gender);
      if (!chart) return null;
      var sizes;
      try { sizes = JSON.parse(chart.dataset.sizes); } catch (error) { return null; }
      if (!Array.isArray(sizes)) return null;
      sizes = sizes.filter(function (size) {
        return typeof size === 'string' && size.trim() && !/^(custom|custom size)$/i.test(size.trim());
      });
      if (!sizes.length) return null;
      return sizes;
    },
    optionLabel: function (gender, size) {
      var chest = measurements(gender, size, ['chest']);
      return size + (chest ? ' — ' + chest : '');
    },
    summary: function (gender, size) {
      var text = measurements(gender, size, ['chest', 'waist']);
      return size + (text ? ' · Body: ' + text : '');
    },
    snapshot: function (anchor, gender, size, customised) {
      if (!anchor) return;
      var line = anchor.nextElementSibling;
      if (!line || !line.hasAttribute('data-pt-size-snapshot')) {
        line = document.createElement('p');
        line.setAttribute('data-pt-size-snapshot', '');
        line.className = 'pt-size-snapshot';
        anchor.after(line);
      }
      var fields = gender === 'GIRLS' || gender === 'BOYS' ? ['chest', 'waist'] : ['chest', 'waist', 'hips'];
      var text = customised ? '' : measurements(gender, size, fields);
      line.replaceChildren();
      if (text) {
        var label = document.createElement('span');
        label.textContent = 'Body measurements';
        var values = document.createElement('span');
        values.textContent = text;
        line.append(label, values);
      }
      line.hidden = !text;
    }
  };

  function updateScrollHints(modal) {
    modal.querySelectorAll('.pt-size-guide-scroll').forEach(function (region) {
      var overflow = region.scrollWidth > region.clientWidth + 1;
      region.previousElementSibling.hidden = !overflow;
      region.tabIndex = overflow ? 0 : -1;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pt-size-guide]');
    if (!trigger || trigger.disabled) return;
    var modal = document.getElementById('modal-pt-size-guide');
    if (!modal || typeof modal.open !== 'function') return;
    var chart = resolveChart(trigger.dataset.ptSizeGuide);
    var content = modal.querySelector('[data-pt-size-guide-content]');
    content.replaceChildren();
    modal.querySelector('#pt-size-guide-title').textContent = chart ? chart.dataset.title : 'Size Guide';
    if (chart) {
      content.appendChild(chart.content.cloneNode(true));
    } else {
      var notice = document.createElement('p');
      notice.textContent = 'The size guide for this person is currently unavailable. Please contact us for sizing help.';
      content.appendChild(notice);
    }
    modal.open(trigger);
    modal.querySelector('.modal__content').scrollTop = 0;
    requestAnimationFrame(function () { updateScrollHints(modal); });
  });
  window.addEventListener('resize', function () {
    var modal = document.getElementById('modal-pt-size-guide');
    if (modal && modal.hasAttribute('open')) updateScrollHints(modal);
  });
})();
